import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { Image, ImageFit } from "@fluentui/react/lib/Image";
import { Link } from "@fluentui/react/lib/Link";
import { Stack } from "@fluentui/react/lib/Stack";
import { Text } from "@fluentui/react/lib/Text";

import { Center } from "Components/Generic/Center";
import { useLogo } from "Hooks/UseLogo";
import { IconButtonWithTooltip } from "Components/Generic/IconButtonWithTooltip";
import { WithTheme } from "Components/Generic/Theme/WithTheme";
import { WithTranslator } from "Components/Generic/Translator";
import { uiAppInit, uiSetUserSettingsOpen } from "Store/Actions";
import { Filter } from "./Filter";
import { IHeaderProps } from "./IHeaderProps";
import { useHeaderStyles } from "./UseHeaderStyles";

export const Header = WithTheme(
  WithTranslator((props: IHeaderProps): JSX.Element => {
    const {
      translator,
      theme: { spacing }
    } = props;
    const dispatch = useDispatch();
    const onUserSettingsClick = useCallback(() => dispatch(uiSetUserSettingsOpen(true)), [dispatch]);
    const onLogoClick = useCallback(() => dispatch(uiAppInit(true)), [dispatch]);
    const { styles, centerStyles } = useHeaderStyles();

    const logo = useLogo();

    return (
      <>
        <Center styleSet={centerStyles}>
          <Stack
            className={styles.root}
            horizontal
            verticalAlign="center"
            horizontalAlign="space-between"
            tokens={{ childrenGap: spacing.l2 }}
          >
            <Stack.Item disableShrink align="center" className={styles.logo}>
              <Link onClick={onLogoClick} as="a">
                <Image title="Logo" imageFit={ImageFit.contain} src={logo} />
              </Link>
            </Stack.Item>
            <Stack.Item disableShrink align="center" className={styles.logoText}>
              <Text variant="xLarge" block nowrap>
                {translator.get(`chub`, `Construction Hub`)}
              </Text>
            </Stack.Item>
            <Stack.Item grow>&nbsp;</Stack.Item>
            <Stack.Item align="end" disableShrink className={styles.filter}>
              <Filter />
            </Stack.Item>
            <Stack.Item align="end" className={styles.settings}>
              <IconButtonWithTooltip
                tooltip={translator.get(`settings.title`, `User Settings`)}
                iconProps={{ iconName: `Settings` }}
                onClick={onUserSettingsClick}
              />
            </Stack.Item>
          </Stack>
        </Center>
        <div className={styles.headerSpacer} />
      </>
    );
  })
);
